<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="blendForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="blend" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                blendForm: () => import('../forms/BlendForm'),
                blend: () => import('../editViews/Blend'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Blend Number', value: 'blendNumber' },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Batch Number', value: 'batchNumber' },
                    { text: 'Volume', value: 'volume' },
                    { text: 'Honey Supplier', value: 'honeySupplier' },
                    { text: 'Has Passed Finished Product Test', value: 'hasPassedFinishedProductTest' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'blends',
                editPageName: 'blend',
                apiMethod: 'Blends',
                claimName: 'Blends',
                formTitle: 'Blend',
                excelTitle: 'Blends',
                hasEditPage: true,
            }
        },
    };
</script>
